import React, { Component } from 'react'
import { Segment, Header } from 'semantic-ui-react'

class Error500 extends Component {
  render() {
    return (
      <Segment basic>
        <Header as="h1">500 Error</Header>
      </Segment>
    )
  }
}

export default Error500
